import {
  postExamAttempt,
  putExamAttempt,
  patchExamAttempt,
  getExamAttempt,
  fetchUsersCertifications,
  fetchUsersVouchers,
  getCertifications,
  getCertificate,
  postVerifyLab,
} from '@/models/certifications'
import { ActionTree, ActionContext } from 'vuex'
import {
  ICertificationsState,
  IRootState,
  IExamAttempt,
  ICertification,
} from '@/@types'

const actions: ActionTree<ICertificationsState, IRootState> = {
  startExamAttempt: async (
    context: ActionContext<ICertificationsState, IRootState>,
    data: { examId: string }
  ) => {
    try {
      const response = await postExamAttempt(data)
      context.commit('UPDATE_CURRENT_EXAM_ATTEMPT', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  finishExamAttempt: async (
    context: ActionContext<ICertificationsState, IRootState>,
    data: { examId: string; attemptId: string; submission: IExamAttempt }
  ) => {
    try {
      const response = await putExamAttempt(data)
      context.commit('UPDATE_CURRENT_EXAM_ATTEMPT', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },

  updateExamAttempt: async (
    context: ActionContext<ICertificationsState, IRootState>,
    data: {
      examId: string
      attemptId: string
      submission: IExamAttempt
      status: string
    }
  ) => {
    try {
      const response = await patchExamAttempt(data)
      context.commit('UPDATE_CURRENT_EXAM_ATTEMPT', response)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },
  resumeExamAttempt: async (
    context: ActionContext<ICertificationsState, IRootState>,
    data: {
      voucherId: string
      attemptId: string
    }
  ) => {
    try {
      const response = await getExamAttempt(data)
      context.commit('UPDATE_CURRENT_EXAM_ATTEMPT', response)
      context.commit('UPDATE_PARTIAL_CERTIFICATION', response.certification)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },

  clearExamStore: (
    context: ActionContext<ICertificationsState, IRootState>
  ) => {
    context.commit('UPDATE_CURRENT_EXAM_ATTEMPT', {})
  },

  updateCurrentCertification: (
    context: ActionContext<ICertificationsState, IRootState>,
    certification: ICertification
  ) => {
    context.commit('UPDATE_CURRENT_CERTIFICATION', certification)
  },

  getUsersCertifications: async (
    context: ActionContext<ICertificationsState, IRootState>
  ) => {
    try {
      const response = await fetchUsersCertifications()
      context.commit('USERS_CERTIFICATIONS', response)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },

  getUsersVouchers: async (
    context: ActionContext<ICertificationsState, IRootState>
  ) => {
    try {
      const response = await fetchUsersVouchers()
      context.commit('USERS_VOUCHERS', response)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },

  getAllCertifications: async (
    context: ActionContext<ICertificationsState, IRootState>
  ) => {
    try {
      const response = await getCertifications()
      context.commit('UPDATE_CERTIFICATIONS_LIST', response.results)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },
  getCertificate: async (
    context: ActionContext<ICertificationsState, IRootState>,
    attemptId: string
  ) => {
    try {
      const response = await getCertificate(attemptId)
      context.commit('UPDATE_CURRENT_CERTIFICATE', response)
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
    }
  },
  setCurrentAttemptScored: (
    context: ActionContext<ICertificationsState, IRootState>,
    currentScoredAttempt: IExamAttempt
  ) => {
    context.commit('UPDATE_CURRENT_SCORED_ATTEMP', currentScoredAttempt)
  },
  verifyLab: async (
    context: ActionContext<ICertificationsState, IRootState>,
    attemptId: string
  ) => {
    try {
      const response = await postVerifyLab(attemptId)
      context.commit('UPDATE_USER_LAB_ATTEMPT', response)
      return response
    } catch (error) {
      const { message } = error
      context.dispatch('app/setError', message, { root: true })
      throw error
    }
  },
}

export default actions
